import {getBenefitAmountGVA6} from 'Quoting/utils/utilities';
import {getCalculatedBenefitAmounts, getMoneyObject} from '../../PlanTemplates/ACC/GVA6';
import {fractureDefaultValues, reductionDetailsDefaults} from '../../PlanTemplates/ACC/benefitDefaults';

export const addPathtoUpdate = (fieldPath: string, value: number, valuesToUpdate:Array<{path:string, newValue: any}>) => {
  valuesToUpdate.push({path: fieldPath, newValue: value});
  return valuesToUpdate;
};

export const buildHospitalBenefitPaths = (units: number, propertyPaths: any, defaultPlanValues: any, valuesToUpdate:Array<{path:string, newValue: any}>) => {
  // build all hospital benefit amount values
  valuesToUpdate = [
    ...valuesToUpdate,
    {
      path: propertyPaths.hospitalAdmissionDetails.benefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCHospitalAdmissionBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.hospitalConfinementDetails.benefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCHospitalConfinementBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.intensiveCareUnitConfinementDetails.benefitAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCIntensiveCareUnitConfinementBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.objectiveSecondOpinionDetails.benefitAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCObjectiveSecondOpinionBenefit.standardBenefitAmount'),
    },
  ];
  return valuesToUpdate;
};

export const buildAllUnitsPaths = (units: number, propertyPaths: any, valuesToUpdate:Array<{path:string, newValue: any}>) => {
  // build all unit fields values
  valuesToUpdate = [
    ...valuesToUpdate,
    {path: propertyPaths.unitsOfAccidentInjuries, newValue: units},
    {path: propertyPaths.followUpTreatmentDetails.units, newValue: units},
    {path: propertyPaths.unitsOfAccAmbulanceUrgentCare, newValue: units},
    {path: propertyPaths.xRayDetails.units, newValue: units},
    {path: propertyPaths.unitsOfEmergencyRoomServices, newValue: units},
    {path: propertyPaths.unitsOfAccAccidentSurgeries, newValue: units},
    {path: propertyPaths.unitsOfDiagnosticPainManagement, newValue: units},
    {path: propertyPaths.unitsOfTreatmentSupportAndRecovery, newValue: units},
    {path: propertyPaths.unitsOfAccidentalDeathAndDismemberment, newValue: units},
    {path: propertyPaths.unitsOfDislocationRider, newValue: units},
  ];
  return valuesToUpdate;
};

export const buildAccidentTreatementUrgentCareBenefitPaths = (
  units: number,
  propertyPaths: any,
  defaultPlanValues: any, 
  valuesToUpdate:Array<{path:string, newValue: any}>
) => {
  // build all benefit amount values for AccidentTreatmentUrgentCareRider
  valuesToUpdate = [
    ...valuesToUpdate,
    {
      path: propertyPaths.ambulanceUrgentCareBenefitBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCAmbulanceUrgentCareBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.ambulanceAirDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCAmbulanceAirBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.ambulanceGroundOrWaterDetailsBenefitAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCAmbulanceGroundOrWaterBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.urgentCareDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCUrgentCareBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.XRaybenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCXRayBenefit.standardBenefitAmount'),
    },
  ];
  return valuesToUpdate;
};

export const buildBenefitEnhancementBenefitPaths = (units: number, propertyPaths: any, defaultPlanValues: any, valuesToUpdate:Array<{path:string, newValue: any}>) => {
  // build all benefit amount values for BenefitEnhancementRider
  valuesToUpdate = [
    ...valuesToUpdate,
    {
      path: propertyPaths.brainInjuryDiagnosisDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCBrainInjuryDiagnosisDetails.standardBenefitAmount'),
    },
    {
      path: propertyPaths.brokenToothDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCBrokenToothBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.burnDegreeDetails[0].burnSize1Amount,
      newValue: units * getMoneyObject(100).amount,
    },
    {
      path: propertyPaths.burnDegreeDetails[0].burnSize2Amount,
      newValue: units * getMoneyObject(500).amount,
    },
    {
      path: propertyPaths.comaDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCComaBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.threeOrFourLimbsAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCParalysisBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.oneOrTwoLimbsAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCParalysisBenefit.standardBenefitAmount') * 0.5,
    },
    {
      path: propertyPaths.lacerationBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCLacerationBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.rehabilitationFacilityBenefitAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCRehabilitationFacilityBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.followUpTreatmentDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCFollowUpTreatmentBenefit.standartBenefitAmount'),
    },
    {
      path: propertyPaths.miscellaneousOutpatientSurgeryDetailsBenefitAmount,
      newValue:
        units *
        getBenefitAmountGVA6(defaultPlanValues, 'ACCMiscellaneousOutpatientSurgeryBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.openAbdominalOrThoracicSurgeryDetailsBenefitAmount,
      newValue: units * 1000,
    },
    {
      path: propertyPaths.tendonLigamentRotatorCuffDetailsWithRepairAmount,
      newValue:
        units *
        getBenefitAmountGVA6(defaultPlanValues, 'ACCTendonLigamentRotatorCuffBenefit.withRepairStandardBenefitAmount'),
    },
    {
      path: propertyPaths.tendonLigamentRotatorCuffDetailsWithoutRepairAmount,
      newValue:
        units *
        getBenefitAmountGVA6(
          defaultPlanValues,
          'ACCTendonLigamentRotatorCuffBenefit.withoutRepairStandardBenefitAmount'
        ),
    },
    {
      path: propertyPaths.generalAnesthesiaDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCGeneralAnesthesiaBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.rupturedDiscDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCRupturedDiscBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.bloodPlasmaPlateletsDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCBloodPlasmaPlateletsBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.eyeInjuryDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCEyeInjuryBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.majorDiagnosticExamDetails.cATBenefitAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCMajorDiagnosticExamBenefit.standardBenefitAmount') * 0.5,
    },
    {
      path: propertyPaths.majorDiagnosticExamDetails.mRIBenefitAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCMajorDiagnosticExamBenefit.standardBenefitAmount') * 0.5,
    },
    {
      path: propertyPaths.painManagementDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCPainManagementBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.companionNonLocalLodgingDetailsBenefitAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCCompanionNonLocalLodgingBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.medicalEquipmentDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCMedicalEquipmentBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.medicalSuppliesDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCMedicalSuppliesBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.medicationDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCMedicationBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.nonLocalTransportationDetailsBenefitAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCNonLocalTransportationBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.postAccidentCommonCarrierTransportationDetailsBenefitAmount,
      newValue:
        units *
        getBenefitAmountGVA6(
          defaultPlanValues,
          'ACCPostAccidentCommonCarrierTransportationBenefit.standardBenefitAmount'
        ),
    },
    {
      path: propertyPaths.oneDeviceAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCProsthesisBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.twoOrMoreDevicesAmount,
      newValue: 2 * units * getBenefitAmountGVA6(defaultPlanValues, 'ACCProsthesisBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.residenceAutomobileModificationDetailsBenefitAmount,
      newValue:
        units *
        getBenefitAmountGVA6(defaultPlanValues, 'ACCResidenceAutomobileModificationBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.therapyDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCTherapyBenefit.standardBenefitAmount'),
    },
  ];
  return valuesToUpdate;
};

export const buildAccidentDeathDismembermentBenefitPaths = (
  units: number,
  propertyPaths: any,
  defaultPlanValues: any, valuesToUpdate:Array<{path:string, newValue: any}>
) => {
  // build all benefit amount values for AccidentDeathDismembermentRider
  valuesToUpdate = [
    ...valuesToUpdate,
    {
      path: propertyPaths.accidentalDeathDetailsBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCAccidentalDeathBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.accidentalDeathCommonCarrierDetailsBenefitAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCAccidentalDeathCommonCarrierBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.bothArmsOrHandsLossAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCAccidentalDismembermentBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.bothLegsOrFeetLossAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCAccidentalDismembermentBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.oneHandOrArmAndOneLegOrFootLossAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCAccidentalDismembermentBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.armOrHandLossAmount,
      newValue:
        units *
        getBenefitAmountGVA6(defaultPlanValues, 'ACCAccidentalDismembermentBenefit.standardBenefitAmount') *
        0.5,
    },
    {
      path: propertyPaths.legOrFootLossAmount,
      newValue:
        units *
        getBenefitAmountGVA6(defaultPlanValues, 'ACCAccidentalDismembermentBenefit.standardBenefitAmount') *
        0.5,
    },
    {
      path: propertyPaths.oneOrMoreFingersLossAmount,
      newValue:
        units *
        getBenefitAmountGVA6(defaultPlanValues, 'ACCAccidentalDismembermentBenefit.standardBenefitAmount') *
        0.1,
    },
    {
      path: propertyPaths.oneOrMoreToesLossAmount,
      newValue:
        units *
        getBenefitAmountGVA6(defaultPlanValues, 'ACCAccidentalDismembermentBenefit.standardBenefitAmount') *
        0.1,
    },
    {
      path: propertyPaths.maximumBenefitAmount,
      newValue:
        units * getBenefitAmountGVA6(defaultPlanValues, 'ACCAccidentalDismembermentBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.hearingLossAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCFunctionalLossBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.sightLossAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCFunctionalLossBenefit.standardBenefitAmount') * 0.5,
    },
    {
      path: propertyPaths.speechLossAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCFunctionalLossBenefit.standardBenefitAmount'),
    },
    {
      path: propertyPaths.functionalLossDetailsMaximumBenefitAmount,
      newValue: units * getBenefitAmountGVA6(defaultPlanValues, 'ACCFunctionalLossBenefit.standardBenefitAmount'),
    },
  ];
  return valuesToUpdate;
};

const dislocationFieldUpdate = (units: any, propertyPaths: any) => {
  const openReductionDetailsPath = propertyPaths.reductionAmountDetails[0];
  const closedReductionDetailsPath = propertyPaths.reductionAmountDetails[1];
  return [
    // New Reduction Amount Updates (open and closed reduction)
    {
      path: openReductionDetailsPath.hipAmount,
      newValue: 3 * reductionDetailsDefaults.hipStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.kneeNoPatellaAmount,
      newValue: 3 * reductionDetailsDefaults.kneeNoPatellaStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.footBonesAmount,
      newValue: 3 * reductionDetailsDefaults.footBonesStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.ankleAmount,
      newValue: 3 * reductionDetailsDefaults.ankleStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.wristAmount,
      newValue: 3 * reductionDetailsDefaults.wristStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.elbowAmount,
      newValue: 3 * reductionDetailsDefaults.elbowStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.shoulderGlenohumeralAmount,
      newValue: 3 * reductionDetailsDefaults.shoulderGlenohumeralStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.handBonesAmount,
      newValue: 3 * reductionDetailsDefaults.handBonesStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.collarboneAcromioclavicularAmount,
      newValue: 3 * reductionDetailsDefaults.collarboneAcromioclavicularStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.twoOrMoreFingersAmount,
      newValue: 3 * reductionDetailsDefaults.twoOrMoreFingersStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.twoOrMoreToesAmount,
      newValue: 3 * reductionDetailsDefaults.twoOrMoreToesStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.oneFingerOrToeAmount,
      newValue: 3 * reductionDetailsDefaults.oneFingerOrToeStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.kneecapAmount,
      newValue: 3 * reductionDetailsDefaults.kneecapStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.lowerJawAmount,
      newValue: 3 * reductionDetailsDefaults.lowerJawStandardBenefitAmount * units,
    },
    {
      path: openReductionDetailsPath.otherDislocationAmount,
      newValue: 3 * reductionDetailsDefaults.otherDislocationStandardBenefitAmount * units,
    },

    {path: closedReductionDetailsPath.hipAmount, newValue: reductionDetailsDefaults.hipStandardBenefitAmount * units},
    {
      path: closedReductionDetailsPath.kneeNoPatellaAmount,
      newValue: reductionDetailsDefaults.kneeNoPatellaStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.footBonesAmount,
      newValue: reductionDetailsDefaults.footBonesStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.ankleAmount,
      newValue: reductionDetailsDefaults.ankleStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.wristAmount,
      newValue: reductionDetailsDefaults.wristStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.elbowAmount,
      newValue: reductionDetailsDefaults.elbowStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.shoulderGlenohumeralAmount,
      newValue: reductionDetailsDefaults.shoulderGlenohumeralStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.handBonesAmount,
      newValue: reductionDetailsDefaults.handBonesStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.collarboneAcromioclavicularAmount,
      newValue: reductionDetailsDefaults.collarboneAcromioclavicularStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.twoOrMoreFingersAmount,
      newValue: reductionDetailsDefaults.twoOrMoreFingersStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.twoOrMoreToesAmount,
      newValue: reductionDetailsDefaults.twoOrMoreToesStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.oneFingerOrToeAmount,
      newValue: reductionDetailsDefaults.oneFingerOrToeStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.kneecapAmount,
      newValue: reductionDetailsDefaults.kneecapStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.lowerJawAmount,
      newValue: reductionDetailsDefaults.lowerJawStandardBenefitAmount * units,
    },
    {
      path: closedReductionDetailsPath.otherDislocationAmount,
      newValue: reductionDetailsDefaults.otherDislocationStandardBenefitAmount * units,
    },
  ];
};

const fractureDislocationFieldUpdate = (units: any, propertyPaths: any) => {
  const openFractureDetailsPath = propertyPaths.fractureDetailsReductionAmountDetails[0];
  const closedFractureDetailsPath = propertyPaths.fractureDetailsReductionAmountDetails[1];

  return [
    // Open Fracture Amount Updates
    {
      path: openFractureDetailsPath.hipAmount,
      newValue: 3 * fractureDefaultValues.hipThighFemurFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.skullFractureNonDepressedNoFaceNoseBonesAmount,
      newValue: 3 * fractureDefaultValues.skullFractureNonDepressedAmount * units,
    },
    {
      path: openFractureDetailsPath.pelvisInclIliumIschiumPubisAcetabulumNoCoccyxAmount,
      newValue: 3 * fractureDefaultValues.pelvisFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.upperArmBetwElbowAndShoulderHumerusAmount,
      newValue: 3 * fractureDefaultValues.armBetweenShoulderAndElbowFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.shoulderBladeScapulaAmount,
      newValue: 3 * fractureDefaultValues.shoulderBladeFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.legTibiaFibulaAmount,
      newValue: 3 * fractureDefaultValues.legFractureAmount * units,
    },
    {path: openFractureDetailsPath.ankleAmount, newValue: 3 * fractureDefaultValues.ankleFractureAmount * units},
    {
      path: openFractureDetailsPath.kneecapPatellaAmount,
      newValue: 3 * fractureDefaultValues.kneecapFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.collarboneClavicleSternumAmount,
      newValue: 3 * fractureDefaultValues.collarBoneFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.forearmRadiusUlnaAmount,
      newValue: 3 * fractureDefaultValues.forearmFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.footOrHeelNoToesAmount,
      newValue: 3 * fractureDefaultValues.footFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.handNoFingersAmount,
      newValue: 3 * fractureDefaultValues.handOrWristFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.lowerJawMandibleNoAlveolarProcessAmount,
      newValue: 3 * fractureDefaultValues.lowerJawFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.twoOrMoreRibsFingersOrToesAmount,
      newValue: 3 * fractureDefaultValues.twoOrMoreRibsFingersToesFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.faceOrNoseBonesNoMandibleOrMaxillaAmount,
      newValue: 3 * fractureDefaultValues.bonesOfFaceFractureAmount * units,
    },
    {path: openFractureDetailsPath.noseAmount, newValue: 3 * fractureDefaultValues.noseFractureAmount * units},
    {
      path: openFractureDetailsPath.oneRibFingerOrToeAmount,
      newValue: 3 * fractureDefaultValues.oneRibFingerToeFractureAmount * units,
    },
    {path: openFractureDetailsPath.coccyxAmount, newValue: 3 * fractureDefaultValues.coccyxFractureAmount * units},
    {
      path: openFractureDetailsPath.skullFractureDepressedNoFaceNoseBonesAmount,
      newValue: 3 * fractureDefaultValues.skullFractureDepressedAmount * units,
    },
    {
      path: openFractureDetailsPath.vertebraeBodyOfNoVertebralProcessesAmount,
      newValue: 3 * fractureDefaultValues.vertebralBodyFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.vertebralProcessesAmount,
      newValue: 3 * fractureDefaultValues.vertebralProcessFractureAmount * units,
    },
    {
      path: openFractureDetailsPath.upperJawMaxillaNoAlveolarProcessAmount,
      newValue: 3 * fractureDefaultValues.upperJawFractureAmount * units,
    },
    {path: openFractureDetailsPath.sternumAmount, newValue: 3 * fractureDefaultValues.sternumFractureAmount * units},
    {
      path: openFractureDetailsPath.anyOtherFractureAmount,
      newValue: 3 * fractureDefaultValues.anyOtherFractureAmount * units,
    },

    // Closed Fracture Amount Updates
    {path: closedFractureDetailsPath.hipAmount, newValue: fractureDefaultValues.hipThighFemurFractureAmount * units},
    {
      path: closedFractureDetailsPath.skullFractureNonDepressedNoFaceNoseBonesAmount,
      newValue: fractureDefaultValues.skullFractureNonDepressedAmount * units,
    },
    {
      path: closedFractureDetailsPath.pelvisInclIliumIschiumPubisAcetabulumNoCoccyxAmount,
      newValue: fractureDefaultValues.pelvisFractureAmount * units,
    },
    {
      path: closedFractureDetailsPath.upperArmBetwElbowAndShoulderHumerusAmount,
      newValue: fractureDefaultValues.armBetweenShoulderAndElbowFractureAmount * units,
    },
    {
      path: closedFractureDetailsPath.shoulderBladeScapulaAmount,
      newValue: fractureDefaultValues.shoulderBladeFractureAmount * units,
    },
    {path: closedFractureDetailsPath.legTibiaFibulaAmount, newValue: fractureDefaultValues.legFractureAmount * units},
    {path: closedFractureDetailsPath.ankleAmount, newValue: fractureDefaultValues.ankleFractureAmount * units},
    {
      path: closedFractureDetailsPath.kneecapPatellaAmount,
      newValue: fractureDefaultValues.kneecapFractureAmount * units,
    },
    {
      path: closedFractureDetailsPath.collarboneClavicleSternumAmount,
      newValue: fractureDefaultValues.collarBoneFractureAmount * units,
    },
    {
      path: closedFractureDetailsPath.forearmRadiusUlnaAmount,
      newValue: fractureDefaultValues.forearmFractureAmount * units,
    },
    {
      path: closedFractureDetailsPath.footOrHeelNoToesAmount,
      newValue: fractureDefaultValues.footFractureAmount * units,
    },
    {
      path: closedFractureDetailsPath.handNoFingersAmount,
      newValue: fractureDefaultValues.handOrWristFractureAmount * units,
    },
    {
      path: closedFractureDetailsPath.lowerJawMandibleNoAlveolarProcessAmount,
      newValue: fractureDefaultValues.lowerJawFractureAmount * units,
    },
    {
      path: closedFractureDetailsPath.twoOrMoreRibsFingersOrToesAmount,
      newValue: fractureDefaultValues.twoOrMoreRibsFingersToesFractureAmount * units,
    },
    {
      path: closedFractureDetailsPath.faceOrNoseBonesNoMandibleOrMaxillaAmount,
      newValue: fractureDefaultValues.bonesOfFaceFractureAmount * units,
    },
    {path: closedFractureDetailsPath.noseAmount, newValue: fractureDefaultValues.noseFractureAmount * units},
    {
      path: closedFractureDetailsPath.oneRibFingerOrToeAmount,
      newValue: fractureDefaultValues.oneRibFingerToeFractureAmount * units,
    },
    {path: closedFractureDetailsPath.coccyxAmount, newValue: fractureDefaultValues.coccyxFractureAmount * units},
    {
      path: closedFractureDetailsPath.skullFractureDepressedNoFaceNoseBonesAmount,
      newValue: fractureDefaultValues.skullFractureDepressedAmount * units,
    },
    {
      path: closedFractureDetailsPath.vertebraeBodyOfNoVertebralProcessesAmount,
      newValue: fractureDefaultValues.vertebralBodyFractureAmount * units,
    },
    {
      path: closedFractureDetailsPath.vertebralProcessesAmount,
      newValue: fractureDefaultValues.vertebralProcessFractureAmount * units,
    },
    {
      path: closedFractureDetailsPath.upperJawMaxillaNoAlveolarProcessAmount,
      newValue: fractureDefaultValues.upperJawFractureAmount * units,
    },
    {path: closedFractureDetailsPath.sternumAmount, newValue: fractureDefaultValues.sternumFractureAmount * units},
    {
      path: closedFractureDetailsPath.anyOtherFractureAmount,
      newValue: fractureDefaultValues.anyOtherFractureAmount * units,
    },
  ];
};

export const buildDislocationFratureRiderBenefitPaths = (units: number, propertyPaths: any, riderType: string, valuesToUpdate:Array<{path:string, newValue: any}>) => {
  const {maximumClosedReductionBenefitAmount, maximumOpenReductionBenefitAmount} = getCalculatedBenefitAmounts(units);
  // build all benefit amount values for DislocationFractureRider
  valuesToUpdate = [
    ...valuesToUpdate,
    {
      path: propertyPaths.maximumClosedReductionBenefitAmount,
      newValue: maximumClosedReductionBenefitAmount?.amount,
    },
    ...dislocationFieldUpdate(units, propertyPaths),
    ...fractureDislocationFieldUpdate(units, propertyPaths),
  ];

  if (riderType == 'Enhanced') {
    valuesToUpdate = [
      ...valuesToUpdate,
      {
        path: propertyPaths.maximumOpenReductionBenefitAmount,
        newValue: maximumOpenReductionBenefitAmount?.amount,
      },
    ];
  }
  return valuesToUpdate;
};
